<template>
  <div style="mb-2">
    <button
      class="btn btn-round btn-outline-primary float-right mb-3" :class="buttonsSize"
      :style="{opacity: (buttons_visible===true?1:0)}"
      ref="validateBtn"
      @click="run_validation"
    >
      {{ $t("message.validate") }}
    </button>
    <button
      :style="{opacity: (buttons_visible===true?1:0)}"
      class="btn btn-round  btn-outline-primary float-right mr-2 mb-3"  :class="buttonsSize"
      @click="run_full_validation"
    >
      {{ $t("message.validate_full") }}
    </button>
    <!--<button v-else class="btn btn-round btn-primary float-right" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{$t('message.validate')}}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item"   @click="run_validation">{{$t('message.validate_contract')}}</a>
                <a class="dropdown-item"  @click="run_full_validation">{{$t('message.validate_full')}}</a>
            </div>-->
    <div
      class="validation-frame"
      :id="'validation-frame' + _uid"
      v-show="show_validation"
    >
      <button @click="show_validation = false" class="btn btn-link text-danger">
        <i class="fa fa-times"></i>
      </button>
      <div class="validation-frame-inner">
        <div
          v-for="(error, i) in validation_errors"
          :key="'val' + i"
          class="alert mt-3 mb-0 rounded"
          :class="'alert' + get_alert_type(error)"
        >
          <div class="font-weight-bold">
            {{ mapName(error.ControlNo) }}
          </div>
          <div>
            {{ mapMessage(error.ControlNo) }}
          </div>
          <button
            @click="go_to_field(error)"
            class="btn btn-sm btn-round btn-white"
            :class="'text' + get_alert_type(error)"
          >
            {{ $t("message.validation.validate_fix_button") }}
          </button>
        </div>
        <div v-if="validation_errors.length == 0">
          {{ $t("message.validate_success") }}
        </div>
      </div>
    </div>
    <div class="clear" style="clear: both"></div>
  </div>
</template>
<script>
export default {
  props: {
    /**
     * new props to do autosave before validation for FormM only at the moment
     */
     has_pre_action: {
      type: Boolean,
      default: false,
     },
     pre_action: {
      type: Function,
      default: ()=>{}
     },
    /**
     * eo new props for FormM
     */
    section: String,
    item: [String, Number],
    action: Function,
    contractId: [String, Number],
    buttonsSize: {
      type: String,
      default: 'btn-sm'
    },
    buttons_visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      validation_errors: [],
      show_validation: false,
      show_banks_error: false,
      show_founder_error: false,
      is_full_validation: false,
    };
  },
  mounted() {
    this.$root.$on("save-and-validate", (data) => {
      // alert(2)
      this.item = data;
      // this.run_validation()
      console.log(this.$refs.validateBtn)
      this.$refs.validateBtn.click();
    });
  },
  methods: {
    /**
     * finds absolute position of the element
     */
    findPos(obj) {
      var curleft = 0;
      var curtop = 0;
      console.log(obj.getBoundingClientRect())

      if (obj.offsetParent) {
        do {
          curleft += obj.offsetLeft;
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));

        return { X: curleft, Y: curtop };
      }
    },
    /**
     * replaces data-name of the field with field ID for validation purposes
     */
    field_name_replace(input) {
      let replaces = {
        post_addr_index: "address_index_",
        post_addr_country: "address_country",
        post_addr_region: "address_region_",
        post_addr_district: "address_district_",
        post_addr_town: "address_town_",
        post_addr_city: "address_city_",
        post_addr_streethouse: "address_street_",
        post_addr_house: "address_house_",
        post_addr_room: "address_room_",

        company_contacts: "company_contacts",
        org_name: "org_name",
        org_oked: "org_oked",
        org_type: "org_type",
        org_residency: "org_residency",

        residency: "residency",
        //add other field names in format data-name: field_id
      };
      return replaces[input];
    },
    /**
     * Navigates user to the field with error
     */
    go_to_field(error) {
      this.action(error);
    },
    /**
     * returns alert CSS class_name depending on the type of the
     *  validation message
     */
    get_alert_type(error) {
      switch (error.Level) {
        case "Предупреждение":
          return "-warning";
          break;
        case "Ошибка":
          return "-danger";
          break;
        default:
          return "-info";
      }
    },
    mapName(id) {
      var nameString =
        "message.validation." + id.replaceAll(".", "_") + "_name";
      console.log("checking names");
      console.log(this.$t(nameString));
      console.log("second try");
      console.log(this.$t("message.validation.Inv_Goods_E002_name"));
      return this.$t(nameString);
    },
    mapMessage(id) {
      var nameString =
        "message.validation." + id.replaceAll(".", "_") + "_message";
      return this.$t(nameString);
    },
    /**
     * Runs validation of the data and displays an error dialog in case
     */
    run_full_validation(event) {
      this.is_full_validation = true;
      if (this.contractId != null) {
        this.item = this.contractId;
      }
      this.run_validation(event);
    },
    run_validation(event) {
      let button_pos = this.findPos(event.target);
      console.log(button_pos, event.target.offsetWidth);
      let validation_frame = document.querySelector(
        "#validation-frame" + this._uid,
      );
      let validation_frame_top = 0;
      if (event.target.offsetWidth + button_pos.X + 300 > window.innerWidth) {
        console.log("this case", event.target.offsetWidth + button_pos.X - 300);
        validation_frame.style.left =
          event.target.offsetWidth + button_pos.X - 300 + "px";
        validation_frame_top = button_pos.Y + event.target.offsetHeight + 10;
        if (
          this.section == "invoice" ||
          this.section == "packinglist" ||
          this.section == "epi" ||
          this.section == "cmr"
        ) {
          validation_frame_top -= 100;
          validation_frame.style.left =
            event.target.offsetWidth + button_pos.X - 540 + "px";
        }
        validation_frame.style.top = validation_frame_top + "px";
        validation_frame.style.width = "300px";
        console.log(validation_frame.style);
        validation_frame.classList.add("top");
        validation_frame.classList.remove("left");
      } else {
        console.log("another this case");
        validation_frame.style.left =
          event.target.offsetWidth + button_pos.X + 10 + "px";
        validation_frame_top = button_pos.Y;
        if (
          this.section == "invoice" ||
          this.section == "packinglist" ||
          this.section == "epi" ||
          this.section == "cmr"
        ) {
          validation_frame_top -= 100;
          validation_frame.style.left =
            event.target.offsetWidth + button_pos.X - 550 + "px";
        }
        validation_frame.style.top = validation_frame_top + "px";
        validation_frame.style.width = "290px";
        validation_frame.classList.add("left");
        validation_frame.classList.remove("top");
      }
      validation_frame.classList.add("arrow");
      switch (this.section) {
        case "account":
          axios
            .get(window.base + "/validate?org_code=" + this.item)
            .then((response) => {
              this.validation_errors = response.data;
              this.show_validation = true;
            });
          break;
        case "contract":
          if (this.is_full_validation) {
            axios
              .get(
                window.base + "/validate/contractFull?contract_id=" + this.item,
              )
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          } else {
            axios
              .get(window.base + "/validate/contract?contract_id=" + this.item)
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          }

          break;
        case "invoice":
          if (this.is_full_validation) {
            axios
              .get(
                window.base + "/validate/contractFull?contract_id=" + this.item,
              )
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          } else {
            axios
              .get(window.base + "/validate/invoice?doc_id=" + this.item)
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          }
          break;
        case "packinglist":
          if (this.is_full_validation) {
            axios
              .get(
                window.base + "/validate/contractFull?contract_id=" + this.item,
              )
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          } else {
            axios
              .get(window.base + "/validate/packinglist?doc_id=" + this.item)
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          }
          break;
        case "epi":
          if (this.is_full_validation) {
            axios
              .get(
                window.base + "/validate/contractFull?contract_id=" + this.item,
              )
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          } else {
            axios
              .get(window.base + "/validate/epi?doc_id=" + this.item)
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          }
          break;
        case "cmr":
          if (this.is_full_validation) {
            axios
              .get(
                window.base + "/validate/contractFull?contract_id=" + this.item,
              )
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          } else {
            axios
              .get(window.base + "/validate/cmr?doc_id=" + this.item)
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          }
          break;
        case "form_m": 
          if(this.has_pre_action){
            this.pre_action().then(id=>{
              this.item = id
              axios
              .get(window.base + "/validate/FormM?form_m_id=" + this.item + (this.is_full_validation?'&isFull=true':'&isFull=false'))
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
            }).catch(()=>{
                console.log('Error saving');
              })
          }else{
            axios
              .get(window.base + "/validate/FormM?form_m_id=" + this.item + (this.is_full_validation?'&isFull=true':'&isFull=false'))
              .then((response) => {
                this.validation_errors = response.data;
                this.show_validation = true;
              });
          }
          break;
      }

      window.addEventListener("scroll", () => {
        // console.log(window.scrollY)
        if (window.scrollY > button_pos.Y + event.target.offsetHeight) {
          validation_frame.style.top = "50px";
          validation_frame.classList.remove("arrow");
        } else {
          validation_frame.style.top =
            validation_frame_top - window.scrollY + "px";
          validation_frame.classList.add("arrow");
        }
      });
    },
  },
};
</script>
<style>
.validation-frame {
  max-height: 100vh;
  overflow-y: auto;
}
</style>
